export default "__VITE_ASSET__8bv0_Fw9__"